<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Audit Compiler Quality</h2>

  <mat-dialog-content style="min-width: 460px; padding-top: 8px;">

    <!-- Confirm / warning -->
    <div *ngIf="state === 'confirm'">
      <p>
        This compares the compiled engine's output against the general engine's output,
        using this transformer's current, real, <b>full</b> input farm (not a sample) and
        its currently active rules.
      </p>
      <div style="display:flex; align-items:flex-start; gap:8px; padding:10px 0; color:#ffa726;">
        <mat-icon style="font-size:18px; height:18px; width:18px; margin-top:1px;">schedule</mat-icon>
        <span>This can take several minutes on a large farm or a config with many rules —
          if the results disagree, every active rule is re-run once to find exactly which
          one first diverges.</span>
      </div>
    </div>

    <!-- Running -->
    <div *ngIf="state === 'running'" style="text-align:center; padding: 32px 0;">
      <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
      <p style="margin-top: 16px; color: #666; font-size: 14px;">
        Running both engines against the full farm — this may take a while...
      </p>
    </div>

    <!-- Error -->
    <div *ngIf="state === 'error'"
         style="display:flex; align-items:flex-start; gap:8px; color:#ff5252; padding: 8px 0;">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Results -->
    <div *ngIf="state === 'results' && report">

      <!-- Top-level conclusion -->
      <div *ngIf="report.overallMatch"
           style="padding:10px 0; margin-bottom:14px; color:#00e676; display:flex; align-items:center; gap:8px;">
        <mat-icon>check_circle</mat-icon>
        <span><b>Match</b> — compiled and general engine output are identical
          ({{ report.generalRowCount | number }} rows).</span>
      </div>

      <div *ngIf="!report.overallMatch"
           style="padding:10px 0; margin-bottom:14px; color:#ff5252; display:flex; align-items:center; gap:8px;">
        <mat-icon>error</mat-icon>
        <span><b>Mismatch found</b> — see the rule below where the two engines first disagree.</span>
      </div>

      <!-- Shape-level mismatch (columns / row count with no rule bisection yet) -->
      <table *ngIf="!report.overallMatch" style="width:100%; border-collapse:collapse; margin-bottom:10px;">
        <tr><td class="lbl">General engine rows</td><td>{{ report.generalRowCount | number }}</td></tr>
        <tr><td class="lbl">Compiled engine rows</td><td>{{ report.compiledRowCount | number }}</td></tr>
        <tr *ngIf="report.columnsOnlyInGeneral?.length">
          <td class="lbl">Columns only in general</td><td>{{ report.columnsOnlyInGeneral.join(', ') }}</td>
        </tr>
        <tr *ngIf="report.columnsOnlyInCompiled?.length">
          <td class="lbl">Columns only in compiled</td><td>{{ report.columnsOnlyInCompiled.join(', ') }}</td>
        </tr>
      </table>

      <!-- Per-rule ("subtransformer") list -->
      <div *ngIf="!report.overallMatch && report.ruleReports?.length">
        <div style="font-weight:500; margin-bottom:6px;">Subtransformer comparison</div>
        <div *ngFor="let rule of report.ruleReports"
             (click)="viewRuleDetail(rule)"
             style="display:flex; align-items:center; gap:8px; padding:8px 10px;
                    border-bottom:1px solid #eee; cursor:pointer;">
          <mat-icon [style.color]="rule.match ? '#00e676' : '#ff5252'" style="font-size:20px; height:20px; width:20px;">
            {{ rule.match ? 'check_circle' : 'cancel' }}
          </mat-icon>
          <span style="flex:1;">{{ rule.ruleName }}</span>
          <span style="color:#666; font-size:12px;">{{ rule.ruleTypeLabel }}</span>
          <mat-icon style="font-size:18px; height:18px; width:18px; color:#999;">chevron_right</mat-icon>
        </div>
        <div *ngIf="untestedRuleCount > 0" style="color:#666; font-size:12px; margin-top:8px;">
          Stopped at the first divergence — {{ untestedRuleCount }} rule(s) after it were not
          checked, since they'd be operating on already-diverged data. Fix this rule and
          re-run the audit to check the rest.
        </div>
      </div>

      <div style="color:#999; font-size:12px; margin-top:12px;">
        Completed in {{ report.elapsedSeconds }}s.
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="padding: 8px 24px 16px;">
    <button mat-button (click)="close()">Close</button>
    <button *ngIf="state === 'confirm'" mat-raised-button color="primary" (click)="startAudit()">
      Start Audit
    </button>
  </mat-dialog-actions>
</div>
